import { render, staticRenderFns } from "./courseCatalogSetting.vue?vue&type=template&id=01db3029&scoped=true&"
import script from "./courseCatalogSetting.vue?vue&type=script&lang=js&"
export * from "./courseCatalogSetting.vue?vue&type=script&lang=js&"
import style0 from "./courseCatalogSetting.vue?vue&type=style&index=0&id=01db3029&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01db3029",
  null
  
)

export default component.exports